'use client';

/**
 * Error boundary for the sign-in page. Catches render/hydration errors and shows
 * a visible message instead of a blank white page.
 * Uses plain <a> instead of next/link so this boundary can render during SSR in
 * standalone/Docker without triggering useContext null.
 */

export default function SignInError({
  error: _error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div
      className="min-h-[60vh] flex items-center justify-center py-12 px-4"
      style={{
        backgroundColor: 'var(--background)',
        color: 'var(--foreground-default)',
      }}
    >
      <div className="max-w-md w-full space-y-6 text-center">
        <h2
          className="text-xl font-semibold"
          style={{ color: 'var(--foreground-default)' }}
        >
          Something went wrong
        </h2>
        <p
          className="text-sm"
          style={{ color: 'var(--foreground-muted)' }}
        >
          The sign-in page could not be loaded. Please try again or return home.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            type="button"
            onClick={reset}
            className="px-4 py-2 rounded-md text-sm font-medium text-white"
            style={{
              backgroundColor: 'var(--primary-default)',
            }}
          >
            Try again
          </button>
          <a
            href="/auth/signin"
            className="px-4 py-2 rounded-md text-sm font-medium border border-gray-300"
            style={{
              color: 'var(--foreground-default)',
              backgroundColor: 'var(--background)',
            }}
          >
            Reload sign in
          </a>
          <a
            href="/"
            className="px-4 py-2 rounded-md text-sm font-medium"
            style={{ color: 'var(--link-default)' }}
          >
            Go home
          </a>
        </div>
      </div>
    </div>
  );
}
